module.exports = __webpack_public_path__ + "assets/img/09b.9520febe.jpg";